import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNextStepAfter, inicioOnboardingPath, isFromOnboarding } from '../utils/onboarding';

const OnboardingContinueAction = ({ stepId, visible, modoOscuro = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  if (!visible || !isFromOnboarding(location.search)) return null;

  const nextStep = getNextStepAfter(stepId);
  const label = nextStep ? `Siguiente: ${nextStep.label}` : 'Ver mi resumen';

  return (
    <button
      type="button"
      onClick={() => navigate(nextStep?.href || inicioOnboardingPath())}
      className={`rounded-lg px-3 py-1.5 text-xs font-semibold text-white shrink-0 ${
        modoOscuro ? 'bg-[#1F80FF] hover:bg-[#004AAD]' : 'bg-[#1F80FF] hover:bg-[#004AAD]'
      }`}
    >
      {label}
    </button>
  );
};

export default OnboardingContinueAction;
